// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"2440":"datadogProfiler","3581":"datadogRecorder","8819":"bc0902ee"}[chunkId] || chunkId) + "." + {"2440":"0ca91133f272c823","3581":"3f1d929b4061f52f","5171":"37350ac05f7937ba","8135":"44d4c5adbdcb3d69","8819":"4a976c1bfbfd1c90","9086":"69522ea792c4403c"}[chunkId] + ".js";
};